import React, { useEffect, useRef, useState } from "react";
import { X, Search, ArrowRight } from "lucide-react";
import { api, imgSrc } from "../lib/api";

const TRENDING = [
  "premières fois",
  "consentement",
  "clitoris",
  "polyamour",
  "Tinder",
  "lubrifiant bio",
];

export default function JardinIntime({ open, onClose, onPickResult }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setQ("");
    setResults([]);
    setTimeout(() => inputRef.current?.focus(), 60);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
    if (!q.trim()) {
      setResults([]);
      return;
    }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/articles", { params: { search: q, limit: 12 } });
        setResults(data);
      } finally {
        setLoading(false);
      }
    }, 220);
    return () => clearTimeout(t);
  }, [q, open]);

  if (!open) return null;

  return (
    <div
      data-testid="jardin-intime-overlay"
      className="fixed inset-0 z-50 bg-[#FFFDF7] overflow-y-auto"
    >
      <div className="mx-auto max-w-[1200px] px-5 lg:px-10 py-8">
        <div className="flex items-center justify-between mb-10">
          <p className="text-xs uppercase font-bold tracking-widest">
            JARDIN INTIME · Recherche
          </p>
          <button
            data-testid="close-jardin-intime"
            onClick={onClose}
            className="brutal-btn brutal-btn-cream !py-2 !px-3"
            aria-label="Fermer"
          >
            <X size={18} />
          </button>
        </div>

        <h2 className="font-display-black text-4xl sm:text-6xl lg:text-8xl tracking-tighter">
          Tape un mot,
          <br />
          on creuse pour toi.
        </h2>

        <div className="mt-10 flex items-center gap-3 border-b-4 border-black pb-2">
          <Search size={28} strokeWidth={2.5} />
          <input
            data-testid="jardin-intime-input"
            ref={inputRef}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Consentement, premières fois, polyamour…"
            className="flex-1 bg-transparent outline-none font-display text-3xl sm:text-5xl placeholder:text-black/30"
          />
        </div>

        {!q && (
          <div className="mt-10">
            <p className="uppercase text-xs font-bold tracking-widest mb-4">
              Suggestions chaudes
            </p>
            <div className="flex flex-wrap gap-2">
              {TRENDING.map((t) => (
                <button
                  key={t}
                  data-testid={`trending-${t.replace(/\s+/g, "-")}`}
                  onClick={() => setQ(t)}
                  className="pill-tag hover:bg-[#FFD01E] cursor-pointer"
                >
                  #{t}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="mt-10 grid sm:grid-cols-2 gap-4" data-testid="search-results">
          {loading && <p className="text-sm">Recherche en cours…</p>}
          {!loading && q && results.length === 0 && (
            <p className="text-sm text-black/60">
              Aucun résultat pour « {q} ». Essaie un autre mot du jardin.
            </p>
          )}
          {results.map((a) => (
            <button
              key={a.id}
              data-testid={`search-result-${a.slug}`}
              onClick={() => onPickResult(a.slug)}
              className="brutal-card text-left p-4 flex gap-4 items-center"
            >
              <img
                src={imgSrc(a.cover_image)}
                alt=""
                className="w-20 h-20 object-cover border-2 border-black rounded-lg"
              />
              <div className="flex-1">
                <p className="text-xs uppercase font-bold tracking-widest text-black/60">
                  {a.category.replace(/-/g, " ")}
                </p>
                <h3 className="font-display text-xl leading-tight mt-1">{a.title}</h3>
              </div>
              <ArrowRight size={20} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
